import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const uploadFileApi = async (inputData,authHeaders) => {
    try {
        const res = await apiCallPost(apiPaths.uploadFile, inputData.filesData, authHeaders);
        if(res){
            return { data: res, status: true};
        }
    } catch (err) {
        return { status: false, errMsg: err.message };
    }
};
